'use client'
/***
 *
 * @file components/Stepper/NextStep.tsx
 * @description Next Step component will be used to move to the next step.
 * @author Ayesha Kumar
 * @organization Truminds Software System
 * @since 7 Jan 2026
 *
 */

import { ReactNode, useEffect, useRef } from "react";

type Props = {
  id?: string,
  children: ReactNode,
  event?: string,
}


const NextStep = ({ id, children, event = "click" }: Props) => {

  const nextStepRef = useRef<HTMLDivElement | null>(null)

  const emitEvent = (e: Event) => {
    nextStepRef?.current?.dispatchEvent(new Event("next_step", { bubbles: true }))
  }

  useEffect(() => {
    nextStepRef?.current?.addEventListener(event, emitEvent);

    return () => {
      nextStepRef?.current?.removeEventListener(event, emitEvent);
    }
  }, [])


  return (
    <div className="NextStep-container" id={id} ref={nextStepRef} data-testid="NextStep">
      {children}
    </div>
  );
};

export default NextStep;
